import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const Favoritos = () => {
    
 

  const usenav = useNavigate();
  useEffect(() => {
    
    console.log("en favoritos");

    var jstring;
    var url;

       jstring = '{"search" : "", "favoritos" : 1 }';
  

    
            url = `${process.env.REACT_APP_API_URL}/alu/search`;

        /* fetch de búsqueda */
        var options = {
          method: 'POST',
          headers: {
          'Content-Type': 'application/json'
          },
          mode: 'cors',
          credential : 'include',
          body:  jstring,
          //JSON.stringify({"code" : 4, "activo" : true}),
          
          };
        
        fetch(url, options)
        .then( response => response.json())
        .then( data => {
            console.log("búsqueda", data);
             usenav('/resultados', { state: { searchdata: data.data } } );
          /*  if ( data.lista.length)
            {

              
              setListSearch(data.lista);

            }          
              */
        })

  } ,[]);
   

  
  return (
   
    <div>

    </div>
  );

}

export default Favoritos;